module.exports = __webpack_public_path__ + "static/media/TvShowBanner (7).f88fad60.png";